const SERVICE_FROM_LABEL = "Service von";
const SERVICE_TO_LABEL = "Service bis";
const TECHNICIAN_LABELS = ["servicetechniker", "techniker"];

const timeToMinutes = (timeStr: string): number => {
    if (!timeStr || typeof timeStr !== 'string') return 0;
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
};

const findTimeFieldValue = (row: any, label: string): string | null => {
    const field = row.find(field => 
      field?.title?.includes(label) &&
      field?.type === 'autocomplete' &&
      Array.isArray(field?.value) &&
      field.value.length > 0
    );
    
    return field?.value[0]?.value || null;
  }


const countSelectedWorkers = (row: any[]): number => {
    if (!row || !Array.isArray(row)) return 1;
    const technicianField = row.find((field) => {
        const title: string = String(field?.title || "").toLowerCase();
        const isAutocomplete = field?.type === "autocomplete";
        const matchesLabel = TECHNICIAN_LABELS.some((label) => title.includes(label));
        return isAutocomplete && matchesLabel;
    });

    if (!technicianField) return 1;
    if (!Array.isArray(technicianField.value)) return 0;
    return technicianField.value.length;
};

const calculateRowWorkedHours = (row: any[]): number => {
    if (!row || !Array.isArray(row)) return 0;
    
    const startTimeField = findTimeFieldValue(row, SERVICE_FROM_LABEL);
    
    const endTimeField = findTimeFieldValue(row, SERVICE_TO_LABEL);
    
    if (startTimeField && endTimeField) {
        const startMinutes = timeToMinutes(startTimeField);
        const endMinutes = timeToMinutes(endTimeField);
        
        const workedMinutes = endMinutes - startMinutes;
        const baseHours = workedMinutes > 0 ? workedMinutes / 60 : 0;
        const workerCount = countSelectedWorkers(row);
        return baseHours * workerCount;
    }
    
    return 0;
};

const calculateTotalWorkedHours = (data: any[][]): number => {
    if (!data || !Array.isArray(data)) return 0;
    
    let totalHours = 0;
    
    data.forEach(row => {
        const rowHours = calculateRowWorkedHours(row);
        totalHours += rowHours;
        
        const technicianCount = countSelectedWorkers(row);
        const hoursPerTechnician = rowHours / technicianCount;
        
        if (hoursPerTechnician >= 8.5) {
            totalHours -= (0.5 * technicianCount);
        }
    });
    
    return totalHours;
};

export { calculateTotalWorkedHours };